enum SurveyRecipientType {
  Groups = 'GROUPS',
  Members = 'MEMBERS',
}

export default SurveyRecipientType;
